import { useBookableResourcesQuery, useEventTypesQuery } from '~/lib/Queries';
import { formatDateTimeLong, formatTime, parseTime } from '~/lib/DateTime.js';
import React from 'react';
import { ToolArguments } from '~/components/assistant/ToolArguments.jsx';

export const ToolArgumentValue = ({ value, k: key, tool }) => {
    const { data: bookableResourcesData } = useBookableResourcesQuery();
    const { data: eventTypesCategoryData } = useEventTypesQuery(true);

    const eventTypesData = eventTypesCategoryData?.types;
    const categoryData = eventTypesCategoryData?.categories;

    function mapBookableResources(ids) {
        if (!bookableResourcesData?.length) {
            return ids.join(', ');
        }
        return bookableResourcesData
            ?.filter(br => ids.includes(br.id))
            .map(br => br.name)
            .join(', ');
    }

    function mapEventTypes(ids) {
        if (!eventTypesData?.length) {
            return ids.join(', ');
        }
        return eventTypesData
            ?.filter(et => ids.includes(et.id))
            .map(et => et.name)
            .join(', ');
    }

    function mapCategories(ids) {
        if (!categoryData?.length) {
            return ids.join(', ');
        }
        return categoryData
            ?.filter(c => ids.includes(c.id))
            .map(c => c.name)
            .join(', ');
    }

    if (Array.isArray(value)) {
        if (typeof value[0] === 'object') {
            return (
                <ul>
                    {value.map((v, idx) => (
                        <li key={idx}>
                            <ToolArguments args={v} k={key} tool={tool} />
                        </li>
                    ))}
                </ul>
            );
        } else {
            // If this is an array of bookable resources or event types map them to names
            if (key === 'bookable_resource_ids') {
                return mapBookableResources(value);
            } else if (key === 'event_type_ids') {
                return mapEventTypes(value);
            } else if (key === 'start') {
                return value.map(v => formatDateTimeLong(v)).join(', ');
            }

            return value.join(', ');
        }
    }

    if (typeof value === 'string' && key === 'settings') {
        try {
            value = JSON.parse(value);
        } catch (err) {
            // ...
        }
    }

    if (typeof value === 'object') {
        if (value && Object.keys(value).length > 0) {
            return <ToolArguments args={value} tool={tool} />;
        } else {
            return '';
        }
    }

    if (key === 'bookable_resource_id') {
        return mapBookableResources([value]);
    } else if (key === 'event_type_id') {
        return mapEventTypes([value]);
    } else if (key === 'event_type_category_id') {
        return mapCategories([value]);
    } else if (
        (key === 'start' || key === 'end') &&
        value.split(':')?.length === 2
    ) {
        // Possible a HH:MM, format it nicer for the user
        return formatTime(parseTime(value));
    } else if (key === 'start' || key === 'end') {
        // Maybe it's a date?
        return formatDateTimeLong(value);
    }

    return value;
};
